module.exports = __webpack_public_path__ + "img/kain-logo.66e573ea.png";